<template>
  <div>
    <div class="api-tips">
      需要在<span class="redClass">【公众号配置】</span>中，完整配置公众号信息，并接入模板的用户才能使用
    </div>
    <div class="configure">
      <div class="nr1">
        <h1>1.配置公众号模板支持微信转账到零钱</h1>
        <p>（1）需要在微信商户号-<span class="redClass">【产品中心】</span>中，找到<span class="redClass">【企业付款到零钱】</span>功能，并开通</p>
        <p>（2）<span class="redClass">需要注册超过90天，且近期30天均有收入</span>的商户号才能开通此功能</p>
        <p>（3）商户号的结算方式 <span class="redClass">必须t+1</span></p>
      </div>
      <div class="nr1 marginTop20">
        <h1>
          2.前往微信商户号【账户中心】-【API安全】，先安装操作证书，再下载API证书 
          <!-- <a href="" class="jump"> >>>安装操作证书引导</a>
          <a href="" class="jump"> >>>下载API证书引导</a> -->
        </h1>
        <div>
          <img src="../../assets/img/wx_temp_img.jpg" alt="">
        </div>
      </div>
      <div class="nr1 marginTop20">
        <h1>
          3.解压文件包，将文件包中的证书pkcs12格式（apiclient_cert.p12）文件进行上传
          <div style="display: inline-block;margin-left: 5px;">
            <el-upload
              :action="url"
              :on-success="handleAvatarSuccessP12"
              :show-file-list="false"
              accept = ".p12"
              list-type="picture">
              <el-button size="small" type="primary">上传证书</el-button>
            </el-upload>
          </div>
          <span v-if="fileName1" style="margin-left: 5px;">{{fileName1}}</span>
        </h1>
      </div>
      <div class="nr1 marginTop20">
        <h1>
          4.解压文件包，将文件包中的证书cert.pem格式（apiclient_cert.pem）文件进行上传
          <div style="display: inline-block;margin-left: 5px;">
            <el-upload
              :action="url"
              :on-success="handleAvatarSuccessPem"
              :show-file-list="false"
              accept = ".pem"
              list-type="picture">
              <el-button size="small" type="primary">上传证书</el-button>
            </el-upload>
          </div>
          <span v-if="fileName2" style="margin-left: 5px;">{{fileName2}}</span>
        </h1>
      </div>
      <div class="nr1 marginTop20 marginBottom120">
        <h1>
          5.解压文件包，将文件包中的证书key.pem格式（apiclient_key.pem）文件进行上传
          <div style="display: inline-block;margin-left: 5px;">
            <el-upload
              :action="url"
              :on-success="handleAvatarSuccesskeyPem"
              :show-file-list="false"
              accept = ".pem"
              list-type="picture">
              <el-button size="small" type="primary">上传证书</el-button>
            </el-upload>
          </div>
          <span v-if="fileName3" style="margin-left: 5px;">{{fileName3}}</span>
        </h1>
      </div>
      <!-- <div class="nr1 marginTop20">
        <h1>
          6.IP白名单设置： 微信公众平台-【安全中心】-【IP白名单设置】，添加IP ：119.23.167.88
        </h1>
      </div>
      <div class="nr1 marginTop20">
        <h1>
          7.请在微信公众号【开发】-【基本配置】-【服务器配置】中，如下图
        </h1>
        <div>
          <img src="../../assets/img/wx_temp_img2.jpg" alt="">
        </div>
        <p>（1）请将url添加到配置中：<span class="redClass">http://h5.toptolink.cn/wx/345/public/callback</span></p>
        <p>（2）随机生成aeskey，加密方式选择<span class="redClass">【兼容】</span>，保存后请务必启用该配置才能生效</p>
        
      </div>
      <div class="nr1 marginTop20">
        <h1>8.配置了该功能，可能会导致您的公众号页面失效，请按照以下步骤恢复：</h1>
        <p>（1）禁用服务器配置</p>
        <p>（2）再修改菜单</p>
        <p>（3）再启用服务器配置</p>
        <p>（4）点击<span class="redClass">“+添加功能插件”</span>页面找自定义菜单<span class="redClass">（这一步非常重要）</span></p>
        <p>（5）<span class="redClass">启用（这一步非常重要）</span></p>
      </div>
      <div class="nr1 marginTop20 marginBottom80">
        <h1>9.配置了该功能，会导致公众号自动回复无法使用</h1>
        <div>
          <img src="../../assets/img/wx_temp_img_3.jpg" alt="">
        </div>
        <p><span class="redClass">提示：建议关闭微信商户号【自动提现到银行卡】功能关闭</span></p>
      </div> -->
      <div class="saveBtn">
        <el-button size="small" type="primary" @click="submitBut">提交数据</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { wechatCert } from "@/api/api.js";
export default {
  data() {
    return{
      url:"cms/file/upload/cert",
      fileName1:"",
      fileName2:"",
      fileName3:"",
      url1:"",
      url2:"",
      url3:"",
      userId:''
    }
  },
  methods: {
    handleAvatarSuccessP12(res,file){
      if(res.code == 200){
        this.fileName1 = file.name;
        this.url1 = res.data.url
      }
    },
    handleAvatarSuccessPem(res,file){
      if(res.code == 200){
        this.fileName2 = file.name;
        this.url2 = res.data.url
      }
    },
    handleAvatarSuccesskeyPem(res,file){
      if(res.code == 200){
        this.fileName3 = file.name;
        this.url3 = res.data.url
      }
    },
    submitBut(){
      let params = {
        p12Cert:this.url1,
        privateCertPath:this.url2,
        privateKeyPath:this.url3,
        userId:this.userId
      };
      wechatCert(params).then(res=>{
        this.$notify({
            title: '成功',
            message: '信息提交成功',
            type: 'success'
          });
      })
    }
  },

  mounted() {

  },
  created() {
    this.userId = this.$route.params && this.$route.params.userId;
  }
};
</script>

<style scoped lang="less">
  .api-tips{
    border: 1px solid #f7e794;
    background: #fcf4ca;
    padding: 5px;
    font-size: 14px;
    text-indent: 5px;
  }
  .redClass{
    color: #ff0000;
    background: #f9f2f4;
  }
  .configure{
    margin-top: 20px;
    .nr1{
      h1{
        font-weight: bold;
        margin-bottom: 8px;
      }
      p{
        color: #606266;
        padding: 5px 0;
        font-size: 14px;
      }
      .jump{
        margin-left: 10px;
        color: #337ab7;
      }
    }
    .marginTop20{
      margin-top: 20px;
    }
  }
  .marginBottom120{
    margin-bottom: 120px;
  }
  .saveBtn{
    background: #F8F8F8;
    padding: 15px 0;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    margin-left: -50px;
    button{
      border-radius: 5px;
      font-size: 14px;
      width: 120px;
      height: 40px;
    }
  }
</style>


